import { render, staticRenderFns } from "./AdvertMgmt.vue?vue&type=template&id=60360f65"
import script from "./AdvertMgmt.vue?vue&type=script&lang=js"
export * from "./AdvertMgmt.vue?vue&type=script&lang=js"
import style0 from "./AdvertMgmt.vue?vue&type=style&index=0&id=60360f65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports